

<template>
    <div class="place ">
         <div  v-if="placeData" v-on:mouseout="hide = true"  class=" data card">
             <div v-on:mouseover="hide = false"  class="card-content">
                <h5 v-on:click="hide = !hide" class = "name" id = "name">{{placeData.name}}</h5> 
                <span v-bind:class ="{hide :hide}" id = "info">
                    <br/><b>Address: </b>{{placeData.location}} <br/>
                    <b>Type: </b> {{placeData.type}} <br/>
                    <b>Description: </b>{{placeData.description}} <br/>
                     By {{placeData.author.name}} <br/>
                </span>
               
             </div>
                  
        </div>
        <div  v-if="placeData" v-on:click="enlarged = !enlarged" class="img">
             <img v-bind:class ="{enlarged :enlarged}" class = "image right" :src="placeData.imageUrl" alt="">
        </div>
            <div class="map">
                
                <div id="floating-panel"></div>
                <div class="google-map" id = "map">
                   <div id="directionsPanel" ></div>
                </div> 
        
    </div>
</div>
</template>
<script>


import firebase from "firebase"
import db from "@/firebase/init"
export default {
    name:"Map",
    data(){
        return{
           address : null,
           placeData:null,
           hide:true,
           enlarged:false,
            
                 lat:null,
                 lng:null,
            
        }
        
    },
    methods:{
        // change(){
        //     this.hide = true
        // },
        renderMap(){
             if(navigator.geolocation){
            navigator.geolocation.getCurrentPosition(pos => {
                this.lat = pos.coords.latitude
                this.lng = pos.coords.longitude

  
        var directionsDisplay = new google.maps.DirectionsRenderer;
        var directionsService = new google.maps.DirectionsService;
     

        var map = new google.maps.Map(document.getElementById('map'), {
          zoom: 7,
          center: {lat: 53.5511, lng: 9.9937}
        });
        directionsDisplay.setMap(map);
        directionsDisplay.setPanel(document.getElementById('right-panel'));

        var control = document.getElementById('floating-panel');
        control.style.display = 'block';
        map.controls[google.maps.ControlPosition.TOP_CENTER].push(control);

        
          this.calculateAndDisplayRoute(directionsService, directionsDisplay);
          console.log(this.lat,this.lng)
          })
          }
        
    
      
      


}   ,
calculateAndDisplayRoute(directionsService, directionsDisplay) {
 
           var start = new google.maps.LatLng( this.lat, this.lng);
          var end = this.placeData.location
        directionsService.route({
          origin: start,
          destination: end,
          travelMode: 'DRIVING'
        }, function(response, status) {
          if (status === 'OK') {
            directionsDisplay.setDirections(response);
          } else {
            window.alert('Directions request failed due to ' + status);
          }
        });
      }

            

           
  
             
        },
    
    mounted(){
  
      
              this.renderMap()
           
            
             
        },
        created(){
           let ref = db.collection("places")
        ref.doc(this.$route.params.place_id).get()
        .then((place) => {
            this.placeData = place.data()
            
        })
        }
    //    beforeMount: async function() {
    //    await created()
    // },
   

    }    
         
 
</script>
<style>
.place .map{
 display: grid;
 

}
.place .google-map{
     
   
    width:100%;
    height:100%;
    margin:0 auto;
    background: #fff;
    position:absolute;
    top:100px;
    /* left:0; */
    z-index:-1;
    
}
.place .img .image{
     position:absolute;
    top:100px;
    right:0;
    width:30%;
    height:50%;
    z-index:2;
    opacity:0.6
}
.place .data{
    position:relative;
    z-index:5;
    opacity:0.8;
    margin:7px;
    padding:0;
   
       
}
#directionsPanel{
  float:right;  
  width:30%;
  height: 100%;
}
.place .name{
    position:relative;
    z-index:4;
    text-transform:uppercase;
    opacity:1;
    color:black;
    margin:0;
    padding:0;
    text-align:center;
}
.place .data .card-content{
    margin-top:0;
    padding-top:0;
    padding-bottom:0;
    margin-bottom:0;
    
}
.place .data .hide{
    display:none
}
.place .img .enlarged{
width:80%;

    margin-left: 10%;
    margin-right: 10%;
height:80%;
opacity:0.8;

}

/* .grid {
  display: grid;
  border: 2px blue solid;
  width: 400px;
  height: 500px;
  grid-template-columns: 100px 50% 200px;
  grid-template-rows: 40% 50% 50px;
} */

</style>





// WEBPACK FOOTER //
// src/components/Place.vue